let assetUrls = {};
function registerAssets(assets) {
    assetUrls = {
        ...assetUrls,
        ...assets
    };
}
function toUrl(name) {
    const url = assetUrls[name] ?? assetUrls[name.replace(/[/.]/g, '_')];
    return ( new URL(url, window.location.href).toString());
}
window.monacoRequire = {
    toUrl
};
export { registerAssets };
